import { inputSelectProps, inputTextProps } from '@/assets/props/defaultProps';
import {
  emailRegExp,
  mobileNoRegExp,
  onlyNumberRegExp,
} from '@/assets/commonRules';
import { familyRelationsOptionItems } from '@/assets/items/defaultItems';

export const personalInformation = {
  title: '기본 인적사항',
  inputs: [
    {
      inputName: 'name',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '이름',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '이름을 입력해 주세요.'],
        },
      },
    },
    {
      inputName: 'mobile_number',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '휴대폰번호',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '휴대폰번호를 입력해 주세요.',
            v => !v || !!v.match(mobileNoRegExp) || '휴대폰번호를 형식에 맞게 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'pw',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '비밀 번호',
          required: true,
          appendIcon: '$complete',
          rules: [
            v=> !!v || '비밀 번호를 입력해 주세요.',
            v => !v || !!v.match(onlyNumberRegExp) || '숫자 를 입력해 주세요',
            v => !v || v.length === 4 || '4자리를 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'password_confirm',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '비밀 번호 확인',
          required: true,
          appendIcon: '$complete',
        },
      },
    },
    {
      inputName: 'birth_date',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '생년월일',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '생년월일을 입력해 주세요.',
            v => !v || !!v.match(onlyNumberRegExp) || '생년월일은 숫자만 입력해 주세요.',
            v => !v || v.length === 8 || '생년월일은 8자리로 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'email',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: 'E-mail',
          appendIcon: '$complete',
          rules: [
            v => !!v || 'E-mail을 입력해 주세요.',
            v => !v || !!v.match(emailRegExp) || 'E-mail을 형식에 맞게 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'address',
      colProps: {
        cols: 12, sm: 12, md: 12, xl: 12,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '거주지 주소',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '거주지 주소를 입력해 주세요.'],
        },
      },
    },
    {
      inputName: 'emergency_contact_relations',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-select',
        inputProps: {
          ...inputSelectProps,
          label: '비상연락처 관계',
          items: familyRelationsOptionItems,
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '비상연락처 관계를 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'emergency_contact',
      colProps: {
        cols: 12, sm: 12, md: 6, xl: 6,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '비상연락처',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '비상연락처를 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'participation_round',
      colProps: {
        cols: 12, sm: 12, md: 12, xl: 12,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        radioOptions: [
          { key: '1차 : 2025.07.07(월)~2025.07.11(금)', value: '1차'},
          { key: '2차 : 2025.07.28(월)~2025.08.01(금)', value: '2차'},
        ],
        inputProps: {
          ...inputTextProps,
          label: '참여희망시기',
          required: false,
          appendIcon: '$complete',
          rules: [],
        },
        default: '1차'
      },
    },
    {
      inputName: 'internship',
      colProps: {
        cols: 12, sm: 12, md: 12, xl: 12,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        radioOptions: [
          { key: '신청', value: '신청'},
          { key: '미신청', value: '미신청'},
        ],
        inputProps: {
          ...inputTextProps,
          label: '현장실습 신청',
          required: false,
          appendIcon: '$complete',
          rules: [],
        },
        default: '1차'
      },
    },
    {
      inputName: 'military',
      colProps: {
        cols: 12, sm: 12, md: 12, xl: 12,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        radioOptions: [
          { key: '군필', value: '군필'},
          { key: '미필', value: '미필'},
          { key: '면제', value: '면제'},
          { key: '해당사항 없음', value: null},
        ],
        inputProps: {
          ...inputTextProps,
          label: '병역구분',
          required: false,
          appendIcon: '$complete',
          rules: [],
        },
      },
    },
  ],
};